function SenderArea(props: any) {
  let myProps = {
    msg_row: {},
    set_msg_row:(inData:any)=>{},
    sender_tel_arr:[],
    ...props
  };
  let msg_row = myProps.msg_row;

  const onChangeInputData=(key:string,value:string)=>{
    myProps.set_msg_row({
      ...msg_row,
      [key]:value
    });
  };

  return (
    <div>
      <div className="write-table-div mt-1">
        <table>
          <colgroup>
            <col width="20%"></col>
            <col width="80%"></col>
          </colgroup>
          <tbody>
            <tr>
              <th>발신자</th>
              <td>
                <input type="text" className="row-input" name="a_sender" value={msg_row.a_sender}
                  onChange={(e: any) => { onChangeInputData(e.target.name, e.target.value); }}
                  placeholder="발신자"
                  style={{ width: "98%" }} />
              </td>
            </tr>
            <tr>
              <th>발신번호</th>
              <td>
                <select className="row-input" name="a_sender_phone_num" value={msg_row.a_sender_phone_num}
                  onChange={(e: any) => { onChangeInputData(e.target.name, e.target.value); }} >
                  <option value="">선택없음</option>
                  {
                    myProps.sender_tel_arr.map((item: any, idx: number) => {
                      return (
                        <option key={idx} value={item.value} >{item.text}</option>
                      );
                    })
                  }
                </select>
              </td>
            </tr>
            <tr>
              <th>제목</th>
              <td>
                <input type="text" className="row-input" name="a_title" value={msg_row.a_title}
                  onChange={(e: any) => { onChangeInputData(e.target.name, e.target.value); }}
                  placeholder="제목"
                  style={{ width: "98%" }} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default SenderArea;